export default {"src":"https://appsumo2next-cdn.appsumo.com/_next/static/media/sumoday-badge.ffe6d9e8.svg","height":21,"width":83};